// extracted by mini-css-extract-plugin
export default {"wrapper":"FormProvider_wrapper__TMZed","divider":"FormProvider_divider__m9EPf"};